import Table from "../../componentsTable/TanStackTable";
import { petitions } from "../../../api/calls";
import { useContext, useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import { DataContext } from "../../../context/DataContext";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";

 export default function TPagos() {
  const { session, idEmpresa } = useContext(DataContext);
  const [filtering, setFiltering] = useState("");
  const [estado, setEstado] = useState(false);
  const [tpago, setTpago] = useState([]);
  const [load, setLoad] = useState(true)

  //MODAL
  const modalRef = useRef(null);
  const modalRef2 = useRef(null);

  const closeModal = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current);
    modalInstance.hide();
  };

  const form1 = useForm(
    {defaultValues: {
      idTpago: '',
      descripcion: '',
      tasa: 0.0,
      dias: 0
    }}
  );
  
  const form2 = useForm(
    {defaultValues: {
      idTpago: '',
      descripcion: '',
      tasa: 0.0,
      dias: 0
    }}
  );

  const columns = [
    {
      header: "ID",
      accessorKey: "idTpago",
    },
    {
      header: "Descripcion",
      accessorKey: "descripcion",
    },
    {
      header: "Dias",
      accessorKey: "dias",
    },
    {
      header: "Tasa",
      accessorKey: "tasa",
    },
    {
      header: "Estado",
      accessorKey: "estado",
      cell: ({ row }) => {
        const value = row.getValue("estado");
        return (
          <span
            className={(value === "S") ? "text-success fw-bold" : "text-danger fw-bold"}
          >
            {(value === "S") ? "🟢" : "🚫"}
          </span>
        );
      },
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-info"
              onClick={() => updateEstado(row.original)}
            >
              <span className="text-body-secondary"> {(row.original.estado === "S") ? "Inhabilitar": "Habilitar"} </span>
            </button>
            <div className="dropdown-divider"></div>
            <button
              className="dropdown-item text-info"
              onClick={() => handleUpdate(row.original)}
            >
              Editar
            </button>
            <button
              className="dropdown-item text-danger"
              onClick={() => deleteTPago(row.original.idTpago)}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    },
  ];

  const updateEstado = async (row) => {
    row.estado = (row.estado === "S") ? "N" : "S"
    const response = await petitions.updateTPago(idEmpresa(), session().token, row)
    if (response.status === "success") {
      if (response.data) {
        setEstado(!estado);
        toast.success("Estado actualizado correctamente"); 
      }
      else{        
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  }

  const sendTPago = form1.handleSubmit(async (data) => {
    data.estado = "S";
    data.dias = data.dias || 0;
    data.tasa = data.tasa || 0.0;

    const response = await petitions.insertTPago(idEmpresa(), session().token, data);
    if (response.status === "success") {
      if (response.data) {
        closeModal();
        setEstado(!estado);
        toast.success("Tipo de pago registrado correctamente");
        form1.reset(); 
      }
      else{
        closeModal();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      closeModal();
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const deleteTPago = (idTPago) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro/a?",
        text: "No podrás cancelar el proceso",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const response = await petitions.deleteTPago(idEmpresa(), session().token, {
            idTPago,
          });
          if (response.status === "success") {
            if (response.data) {
              setEstado(!estado);
              toast.success("Tipo de pago eliminado correctamente"); 
            }
            else{
              toast.warning("Ocurrió un problema, inténtelo mas tarde");  
            }            
          } else {
            var msg = typeof response.code === "string" ? response.message : response.data;
            toast.error(msg);
          }
        }
      });
  };

  const updateTPago = form2.handleSubmit(async (data) => {
    data.estado = 'S'
    const response = await petitions.updateTPago(idEmpresa(), session().token, data)
    if (response.status === "success") {
      if (response.data) {
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
        setEstado(!estado);
        toast.success("Tipo de pago actualizado correctamente"); 
      }
      else{
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const handleUpdate = (row) => {
    form2.setValue('idTpago', row.idTpago,{ shouldValidate: true })
    form2.setValue('descripcion', row.descripcion,{ shouldValidate: true })
    form2.setValue('dias', row.dias,{ shouldValidate: true })
    form2.setValue('tasa', row.tasa,{ shouldValidate: true })
    const modal = new window.bootstrap.Modal(modalRef2.current);
    modal.show();
  };

  useEffect(() => {
    const fetchTPago = async () => {
      setLoad(true)
      const obj = session();
      const response = await petitions.getTPago(idEmpresa(), obj.token);
      if (response.status === "success") {
        setTpago(response.data);
        setLoad(false)
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPago();
  }, [idEmpresa, session, estado]);

  return (
    <>
      <div className="mb-9">
        <div className="row g-2 mb-4">
          <div className="col-auto">
            <h2 className="mb-0">Tipos de pago</h2>
          </div>
        </div>
        <div className="mb-4">
          <div className="row g-10">
            <div className="col-auto">
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar tipo de pago"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
            </div>
            <div className="col-auto">
              <button className="btn btn-link text-body me-4 px-0" onClick={() => exportToExcel_v1(tpago, columns, "tipos_de_pago")}>
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <button
                className="btn btn-primary rounded-4"
                data-bs-toggle="modal"
                data-bs-target="#modalAgregarTPago"
              >
                <span className="fas fa-plus me-2"></span>Nuevo tipo de pago
              </button>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-responsive scrollbar-overlay mx-n1 px-1">
            {load ? (
                <TableLoad />
            ) : (
                <Table
                  data={tpago}
                  columns={columns}
                  filtering={filtering}
                  setFiltering={setFiltering}
                />
            )}
          </div>
        </div>
      </div>

      {/* MODALS */}
      <div
        className="modal fade"
        id="modalAgregarTPago"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de tipo de pago
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendTPago}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Código
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("idTpago", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      minLength: {
                        value: 3,
                        message: "El código debe ser de 3 digitos",
                      },
                      maxLength: {
                        value: 3,
                        message: "El código debe ser de 3 digitos",
                      },
                    })}
                  />
                  {form1.formState.errors?.idTpago && (
                    <code>{form1.formState.errors.idTpago.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Descripcion
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form1.register("descripcion", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                  />
                  {form1.formState.errors?.descripcion && (
                    <code>{form1.formState.errors.descripcion.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Días
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="number"
                    {...form1.register("dias", {})}
                  />
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Tasa
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="number"
                    step="any"
                    {...form1.register("tasa", {})}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Editar de tipo de pago
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={updateTPago}>
              <div className="modal-body">
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Código
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    disabled
                    {...form2.register("idTpago", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      minLength: {
                        value: 3,
                        message: "El código debe ser de 3 digitos",
                      },
                      maxLength: {
                        value: 3,
                        message: "El código debe ser de 3 digitos",
                      },
                    })}
                  />
                  {form2.formState.errors?.idTpago && (
                    <code>{form2.formState.errors.idTpago.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Descripcion
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="text"
                    {...form2.register("descripcion", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                  />
                  {form2.formState.errors?.descripcion && (
                    <code>{form2.formState.errors.descripcion.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Días
                  </label>
                  <input
                    className="form-control rounded-4" 
                    id="exampleFormControlInput"
                    type="number"
                    {...form2.register("dias", {})}
                  />
                </div>
                <div className="mb-2">
                  <label
                    className="form-label"
                    htmlFor="exampleFormControlInput"
                  >
                    Tasa
                  </label>
                  <input
                    className="form-control rounded-4"
                    id="exampleFormControlInput"
                    type="number"
                    step="any"
                    {...form2.register("tasa", {})}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

